<div style="display: flex; align-items: center; justify-content: center;">
    <img [src]="data?.linkProductImg" class="productImgModal" alt="">
</div>
<div style="margin-top: 0.75rem;">
    <small style="font-weight: bold;">{{ data.titulo }}</small>
    <p>{{ data.descricao }}</p>
</div>